import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { CourseService } from '../../../services/course.service';

@Component({
  selector: 'app-create-course',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './create-course.component.html',
  styleUrl: './create-course.component.scss'
})
export class CreateCourseComponent {
   @Input() type: string = 'Create'; // Create | Update
  @Input() courseData: any; // renamed for consistency
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Input() allDepartments: any[] = [];

  isSubmitted = false;
  btnLoading = false;

  courseForm: FormGroup;
  statusOptions = ["Active", "Inactive"];

  constructor(
    private fb: FormBuilder,
    private api: CourseService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {
    this.courseForm = this.fb.group({
      name: ['', Validators.required],
      code: ['', Validators.required],
      duration: ['', [Validators.required, Validators.min(1)]],
      dept_id: ['', Validators.required],
      description: [''],
      status: ['Active', Validators.required],
      organization_id: [this.localStorage.getOrganizationId() || '']
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.courseData) {
      console.log(this.courseData);
      this.courseForm.patchValue({
        name: this.courseData.name,
        code: this.courseData.code,
        duration: this.courseData.duration,
        description: this.courseData.description,
        dept_id: this.courseData.dept_id,
        status: this.courseData.status
      });
    }
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.courseForm.valid) {
      this.btnLoading = true;
      const formData = this.courseForm.value;

      const payload : any = {
        ...formData,
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId()
      };

      if (this.type === 'Update') {

        payload.course_id = this.courseData?.course_id;

        this.api.updateCourse(payload).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Course updated successfully!'
            });
            this.reload.emit();
            this.handleCloseDialog();
          },
          error: (error) => {
            this.btnLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.error.message || 'Something went wrong!'
            });
          },
          complete: () => {
            this.btnLoading = false;
          }
        });
      } else {
        this.api.createCourse(payload).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Course created successfully!'
            });
            this.reload.emit();
            this.handleCloseDialog();
          },
          error: (error) => {
            this.btnLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.error.message || 'Something went wrong!'
            });
          },
          complete: () => {
            this.btnLoading = false;
          }
        });
      }
    }
  }
}
